<template>
  <div :class="divclass">
    <autocomplete
      ref="autocomplete"
      :url="url"
      anchor="name"
      param="query"
      label="name"
      :classes="classes"
      :on-input="onInput"
      :options="options"
      :on-select="select"
      :debounce="200"
      :custom-params="{ exclude: exclude, include: include }"
      :placeholder="placeholder"
      :process="processSuggestData"
      :on-should-render-child="renderChild"
      :on-should-get-data="doAjax"
    />
    <!--<span id="searchclear" class="fa fa-remove" v-if="!empty" @click="clear"></span>-->
  </div>
</template>

<script>
import Autocomplete from 'vue2-autocomplete-js'
import { defaultErrorMessage } from '@/helpers'
import _escape from 'lodash/escape'

export default {
  name: 'Suggest',

  components: {
    Autocomplete,
  },

  props: {
    url: {},
    clearOnSelect: {
      default: false,
      type: Boolean,
    },
    placeholder: {
      default: () => {
        return Lang.get('core.search') + '...'
      },
    },
    exclude: {},
    include: {},
    divClasses: '',
    lti: {
      default: false,
      type: Boolean,
    },
  },

  data () {
    return {
      classes: {
        input: 'form-control',
      },
      options: [],
      empty: true,
    }
  },

  computed: {
    divclass () {
      return this.divClasses
    },

  },

  methods: {
    select (data) {
      if (data.id == -1) {
        this.clear()
        return
      }
      this.$emit('select', data.id, data.name)

      if (this.clearOnSelect === true) {
        this.$refs.autocomplete.setValue('')
      }
    },

    // override the do ajax from the library to support POST request to our endpoint
    doAjax (val) {
      // this is the autocomplete object
      const autocompleteRef = this.$refs.autocomplete

      // Callback Event
      autocompleteRef.onBeforeAjax ? autocompleteRef.onBeforeAjax(val) : null

      // Compose Params
      const params = typeof autocompleteRef.customParams === 'undefined' ? {} : autocompleteRef.customParams
      params[autocompleteRef.param] = val

      const config = {
        onUploadProgress: progressEvent => {
          if (data.lengthComputable && autocompleteRef.onAjaxProgress) {
            autocompleteRef.onAjaxProgress(data)
          }
        },
      }

      // Init Ajax
      if (this.lti === true) {
        this.$store.dispatch(this.url, { postData: params }).then(({ data }) => {
          // Callback Event
          autocompleteRef.onAjaxLoaded ? autocompleteRef.onAjaxLoaded(data) : null
          autocompleteRef.json = autocompleteRef.process ? autocompleteRef.process(data) : data
        }).catch(error => defaultErrorMessage(error))
      } else {
        axios.post(autocompleteRef.url, params).then(({ data }) => {
          // Callback Event
          autocompleteRef.onAjaxLoaded ? autocompleteRef.onAjaxLoaded(data) : null
          autocompleteRef.json = autocompleteRef.process ? autocompleteRef.process(data) : data
        }).catch(error => defaultErrorMessage(error))
      }

      // not supported from library: custom request headers
    },

    processSuggestData (json) {
      if (json.length == 0) {
        json.push({
          id: -1,
          name: this.trans('filters.no_results'),
        })
      }
      return json
    },

    renderChild (data) {
      if (data.id == -1) {
        return '<em>' + _escape(data.name) + '</em>'
      }
      return _escape(data.name)
    },

    clear () {
      this.$refs.autocomplete.setValue('')
      this.$emit('clear')
      this.empty = true
    },

    onInput (input) {
      if (input == '') {
        this.$emit('clear')
        this.empty = true
      }
      this.empty = false
    }
    ,
  },
}
</script>

<style scoped>
    #searchinput {
        width: 200px;
    }

    #searchclear {
        position: absolute;
        right: 10px;
        top: 0;
        bottom: 0;
        height: 14px;
        margin: auto;
        font-size: 14px;
        cursor: pointer;
        color: #ccc;
    }
</style>

<style>
    .autocomplete-wrapper .autocomplete-input:focus {
        border-color: #25167a;
    }

    .autocomplete-wrapper .autocomplete ul:before {
        content: none;
    }

    .autocomplete-wrapper .autocomplete ul {
        padding: 5px;
        margin-right: 20px;
        z-index: 10;
        margin-top: 0;
        box-shadow: 0 2px 5px 0 #25167a;
        max-width: 500px;
    }

    .autocomplete-wrapper .autocomplete ul li.focus-list a {
        background-color: #25167a;
    }
</style>
